import {
  Activity,
  ArrowLeftRight,
  AudioLines,
  BarChart3,
  BookOpen,
  Bot,
  Building2,
  Cable,
  Contact,
  FolderKanban,
  History,
  LayoutDashboard,
  Languages,
  MessageCircle,
  Mic,
  Music,
  Phone,
  PhoneCall,
  PhoneIncoming,
  RadioTower,
  Package,
  ReceiptText,
  Server,
  Settings,
  ShieldAlert,
  Stethoscope,
  Timer,
  Undo2,
  UserPlus,
  Users,
  Wand2,
  Workflow,
  type LucideIcon,
} from "lucide-react";

export interface SidebarChild {
  label: string;
  href: string;
  badge?: number;
}

export interface SidebarItem {
  label: string;
  href?: string;
  icon: LucideIcon;
  children?: SidebarChild[];
}

export interface SidebarSection {
  label?: string;
  items: SidebarItem[];
}

export const CLIENT_SIDEBAR_SECTIONS: SidebarSection[] = [
  {
    label: "Overview",
    items: [
      { label: "Dashboard", href: "/", icon: LayoutDashboard },
      {
        label: "Analytics",
        icon: BarChart3,
        children: [
          { label: "Performance", href: "/analytics" },
          { label: "Call Intelligence", href: "/call-analytics" },
          { label: "Prompt Insights", href: "/call-analytics/improvements" },
          { label: "Intelligence Settings", href: "/call-analytics/settings" },
        ],
      },
    ]
  },
  {
    label: "Sales & Ops",
    items: [
      { label: "SFA", href: "/crm", icon: Contact },
      {
        label: "Workflows",
        icon: Workflow,
        children: [
          { label: "Overview", href: "/home/automation" },
          { label: "Upload Contacts", href: "/home/automation/contacts" },
          { label: "Schedule Workflow", href: "/home/automation/schedule" },
        ],
      },
      {
        label: "Batch Workspace",
        icon: PhoneCall,
        children: [
          { label: "Active Batches", href: "/batch" },
          { label: "Callbacks", href: "/batch/callbacks" },
        ],
      },
      { label: "Phone Numbers", href: "/phone-numbers", icon: Phone },
      { label: "Call History", href: "/call-history", icon: History },
    ]
  },
  {
    label: "Intelligence",
    items: [
      {
        label: "WhatsApp",
        icon: MessageCircle,
        children: [
          { label: "Overview", href: "/whatsapp/overview" },
          { label: "Chatbot", href: "/chatbot" },
          { label: "Import Contact", href: "/whatsapp/contacts" },
          { label: "My Chat", href: "/whatsapp/conversations" },
          { label: "Template Studio", href: "/whatsapp/templates" },
          { label: "Campaign", href: "/whatsapp/campaigns" },
        ],
      },
      { label: "Voices", href: "/voices", icon: Mic },
      { label: "Knowledge", href: "/knowledge", icon: BookOpen },
      { label: "Supervisor", href: "/supervision", icon: RadioTower },
      { label: "Timeliner", href: "/timeliner", icon: Timer },
    ]
  },
  {
    label: "Administration",
    items: [
      { label: "Organisation", href: "/organisation", icon: Building2 },
      { label: "Products", href: "/products", icon: Package },

      { label: "Audit & Billing", href: "/billing", icon: ReceiptText },
      { label: "Settings", href: "/settings", icon: Settings },
    ]
  }
];

export const ADMIN_SIDEBAR_NAV: SidebarItem[] = [
  { label: "User Access", href: "/admin/users", icon: Users },
  { label: "Voice Models", href: "/admin/voice", icon: Mic },
  { label: "Background Audio", href: "/admin/background-audio", icon: Music },
  { label: "Create Account", href: "/admin/accounts", icon: UserPlus },
  { label: "Carrier Trunks", href: "/admin/carrier-trunks", icon: Cable },
  { label: "DID Numbers", href: "/admin/did-numbers", icon: PhoneCall },
  { label: "Inbound Routes", href: "/admin/inbound-routes", icon: PhoneIncoming },
  { label: "Client Groups", href: "/admin/client-groups", icon: FolderKanban },
  { label: "Products", href: "/admin/products", icon: Package },
  { label: "Refund Requests", href: "/admin/refund-requests", icon: Undo2 },
  { label: "Providers", href: "/admin/providers", icon: Building2 },
  { label: "Deploy GPU", href: "/admin/deploy-gpu", icon: Server },
  { label: "Move Prompts", href: "/admin/prompts", icon: ArrowLeftRight },
  { label: "Instant Clone", href: "/admin/instant-clone", icon: Wand2 },
  { label: "Pronunciations", href: "/admin/pronunciations", icon: Languages },
  { label: "Patient Library", href: "/admin/patient-library", icon: Stethoscope },
  { label: "Demo Prompts", href: "/admin/demo-prompts", icon: Bot },
  { label: "Spam Detection", href: "/admin/spam-detection", icon: ShieldAlert },
  { label: "Current Stats", href: "/admin/current-stats", icon: Activity },
  { label: "Admin Settings", href: "/admin/settings", icon: Settings },
];
